import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { Home, BookOpen, Trophy, Download, LogIn, UserCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL || "";

// Days until the RTSE test date (admin-set); falls back to the coming Sunday when unset.
const daysUntil = (dateStr) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (dateStr) return Math.round((new Date(dateStr + "T00:00:00") - today) / 86400000);
  const wd = today.getDay();
  return wd === 0 ? 0 : 7 - wd;
};

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const [rtseDate, setRtseDate] = useState(undefined); // undefined = loading, null = not set
  useEffect(() => {
    let ok = true;
    axios.get(`${API}/api/site/rtse-test-date`)
      .then((r) => { if (ok) setRtseDate(r.data?.date || null); })
      .catch(() => { if (ok) setRtseDate(null); });
    return () => { ok = false; };
  }, []);
  const days = useMemo(() => (rtseDate === undefined ? null : daysUntil(rtseDate)), [rtseDate]);
  const showBadge = days != null && days >= 0 && days <= 60;

  const account = user ? { name: "Portal", href: user.role === "admin" ? "/admin" : user.role === "faculty" ? "/faculty-desk" : "/portal", icon: UserCircle } : { name: "Login", href: "/login", icon: LogIn };
  const tabs = [{ name: "Home", href: "/", icon: Home }, { name: "Courses", href: "/courses", icon: BookOpen }, { name: "RTSE 3.0", href: "/rtse", icon: Trophy, cls: "pbn-rtse" }, { name: "Downloads", href: "/downloads", icon: Download, cls: "pbn-download" }, account];
  return <nav data-testid="mobile-bottom-nav" aria-label="Quick navigation" className="public-bottom-nav lg:hidden fixed bottom-0 inset-x-0 z-40">
    <ul className="grid grid-cols-5 max-w-2xl mx-auto">
      {tabs.map(({ name, href, icon: Icon, cls = "" }) => {
        const active = href === "/" ? pathname === "/" : pathname.startsWith(href);
        return <li key={name} className="relative min-w-0"><Link to={href} data-testid={`mobile-nav-${href === "/rtse" ? "rtse" : name.toLowerCase()}`} aria-current={active ? "page" : undefined} className={`pbn-item ${cls} ${active ? "pbn-active" : ""} flex min-h-[68px] flex-col items-center justify-center gap-1 px-1 text-[11px] font-semibold`}><span className="pbn-chip inline-flex items-center justify-center w-10 h-7 rounded-lg"><Icon className="w-5 h-5" strokeWidth={active ? 2.4 : 1.9} /></span>{name}</Link></li>;
      })}
    </ul>
  </nav>;
}
